export const PATH_KNOWLEDGE =
    '/oxy365/:category(all|diet|motivation|tips|excercise|chefs-advice|psychodietetics)';
export const PATH_KNOWLEDGE_ALL_ARTICLES = '/oxy365/all';
export const PATH_KNOWLEDGE_ARTICLE = '/oxy365/:article';
